import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'c/:participantAuthKey',
    loadComponent: () =>
      import('./conversation/conversation.component').then((m) => m.ConversationComponent),
  },
  {
    path: 'error',
    loadComponent: () => import('./error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: 'error',
  },
];
